<template>
  <div id="app">
    <router-view></router-view>  <!-- Хуудас шилжих -->
  </div>
</template>

<script>

export default {
  components: {
  }
}
</script>
